<template>
  <div>
    <h1 class="sr-only">How to Charge Your EV</h1>
    <YoutubeHeader />
    <Tabs v-model="selectedTab" />
    <TabContent show-banner :selected-tab="selectedTab" />
  </div>
</template>

<script>
import YoutubeHeader from '@/components/YoutubeHeader.vue';
import Tabs from '@/components/ChargeYourEvTabs.vue';
import TabContent from '@/components/ChargeYourEvTabContent.vue';

export default {
  name: 'ChargingYourEv',
  components: {
    YoutubeHeader,
    Tabs,
    TabContent,
  },
  metaInfo: {
    title: `How to Charge Your EV | Electrify America`,
    meta: [
      {
        name: 'description',
        content: `Learn how to charge your EV in a few simple steps with Electrify America, whether you're using the mobile app, your vehicle's touchscreen, or paying directly at the charger.`,
      },
    ],
    link: [{ rel: 'canonical', href: 'https://www.electrifyamerica.com/charging-your-ev/' }],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'HowTo',
          name: 'How to Charge Your EV at Electrify America',
          step: [
            {
              '@type': 'HowToStep',
              position: 1,
              name: 'Search for a charging station',
              text: 'Search for a charging station in the Electrify America app or by searching directly in Google Maps.',
            },
            {
              '@type': 'HowToStep',
              position: 2,
              name: 'Select a charging station',
              text: "After you've parked at the charger, select your charging station in the app.",
            },
            {
              '@type': 'HowToStep',
              position: 3,
              name: 'Select a charger',
              text: 'Confirm the charger number in the app matches the number on your charger, found above the charger screen.',
            },
            {
              '@type': 'HowToStep',
              position: 4,
              name: 'Start a charge',
              text: 'Confirm your payment method or membership plan, plug in the connector until it clicks, and tap Start Charging in the app.',
            },
            {
              '@type': 'HowToStep',
              position: 5,
              name: 'Charge',
              text: 'Session details appear on your phone and on the charger. Press Stop in the app to manually end the session.',
            },
          ],
        },
      },
    ],
  },
  data() {
    return {
      selectedTab: 'InTheApp',
    };
  },
};
</script>
